<ejs-tab id="element"
         class="mt-2"
         [animation]="animation"
         (created)="onTabsCreated($event)"
         (selecting)="select($event)"
         heightAdjustMode="fill">
  <e-tabitems>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.file.name-configuration.title' | translate}}
        @if(!configurationFormService.configurationFormFileName.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-file-name></app-configuration-form-file-name>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.title' | translate}}
        @if(!configurationFormService.configurationFormFileFields.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-file-fields></app-configuration-form-file-fields>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.file.line-based-attributes-configuration.title' | translate}}
        @if(!configurationFormService.configurationFormFileLineBasedAllAttributes.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-file-linebased-all-attributes></app-configuration-form-file-linebased-all-attributes>
      </ng-template>
    </e-tabitem>
    <e-tabitem>
      <ng-template #headerText>
        {{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.title' | translate}}
        @if(!configurationFormService.configurationFormFileFilter.valid){
          <span class="icon-warning--alt text-warning ms-2"></span>
        }
      </ng-template>
      <ng-template #content>
        <app-configuration-form-file-filter></app-configuration-form-file-filter>
      </ng-template>
    </e-tabitem>
  </e-tabitems>
</ejs-tab>
